var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavBar',{staticClass:"PlainNavBar"},[(_vm.superuser)?_c('router-link',{staticClass:"d-inline-flex align-center mr-3",attrs:{"to":{ name: 'Dashboard' }}},[_c('i',{staticClass:"far fa-fw fa-gear icon"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }